import { useEffect, useRef, useState } from 'react';
import { T } from 'gt-react';
import { Button } from 'src/components/ui/button';
import { registerUpdateOverlayService } from 'src/services/updateOverlayService';

export function UpdateRequiredPanel({ titleId }: { titleId?: string }) {
  return (
    <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-2xl">
      <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-blue-50 text-blue-600">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-7 w-7"
          aria-hidden="true"
        >
          <path d="M21 12a9 9 0 1 1-3-6.7" />
          <path d="M21 4v5h-5" />
        </svg>
      </div>
      <h2 id={titleId} className="mb-2 text-xl font-semibold text-slate-900">
        <T>Update required</T>
      </h2>
      <p className="mb-6 text-sm leading-relaxed text-slate-600">
        <T>
          This page is out of date and may no longer work correctly. Refresh to
          load the latest version.
        </T>
      </p>
      <Button
        className="w-full"
        onClick={() => window.location.reload()}
        autoFocus
      >
        <T>Refresh page</T>
      </Button>
    </div>
  );
}

export function UpdateRequiredOverlay() {
  const [visible, setVisible] = useState(false);
  const dialogRef = useRef<HTMLDialogElement | null>(null);

  useEffect(() => {
    registerUpdateOverlayService(() => setVisible(true));
    return () => registerUpdateOverlayService(null);
  }, []);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (visible && !dialog.open) {
      dialog.showModal();
    }
  }, [visible]);

  if (!visible) return null;

  return (
    <dialog
      ref={dialogRef}
      aria-labelledby="update-required-title"
      onCancel={(e) => e.preventDefault()}
      className="m-0 h-full max-h-none w-full max-w-none bg-transparent p-0 text-slate-900 backdrop:bg-slate-900/80 backdrop:backdrop-blur-sm"
    >
      <div className="flex h-full w-full items-center justify-center p-4">
        <UpdateRequiredPanel titleId="update-required-title" />
      </div>
    </dialog>
  );
}
